import PropTypes from 'prop-types'
import React from 'react'
import ShowHide from './ShowHide'
import { Tabs, Tab } from './Tabs'
import { FlexGrid, FlexItem } from './flexgrid'
import './SubNavigation.css'

const SubNavigation = props => {
  const { title, items, active, breadcrumbs, rightChildren } = props
  return (
    <div className='SubNavigation'>
      <div className='SubNavigation-inner'>
        <FlexGrid alignItems='center' justifyContent='space-between'>
          <FlexItem flex='1'>
            <FlexGrid alignItems='center'>
              <FlexItem>
                <div className='SubNavigation-breadcrumbs'>
                  <ShowHide show={breadcrumbs.length > 0}>
                    {breadcrumbs.map(({ href, text, rel }) =>
                      <a key={`${href}_${text}`} className='SubNavigation-breadcrumbItem' href={href} rel={rel}>
                        {text}
                      </a>
                    )}
                  </ShowHide>
                </div>
              </FlexItem>
              <FlexItem>
                <div className='SubNavigation-title'>
                  <h4>{title}</h4>
                </div>
              </FlexItem>
            </FlexGrid>
          </FlexItem>
          <FlexItem flex='1'>
            <FlexGrid justifyContent='center'>
              <FlexItem>
                <div style={{ position: 'relative', top: '14px' }}>
                  <ShowHide show={!!items}>
                    <Tabs hideBorder>
                      {items.filter(i => i.visible).map((item, index) =>
                        <Tab
                          key={`tab_${item.name}_${index}`}
                          active={active === item.name}
                          href={item.href}
                          badge={item.badge}
                          rel={item.rel}
                          target={item.target}>
                          {item.name}
                        </Tab>
                      )}
                    </Tabs>
                  </ShowHide>
                </div>
              </FlexItem>
            </FlexGrid>
          </FlexItem>
          <FlexItem flex='1'>
            <FlexGrid justifyContent='flex-end'>
              <FlexItem>
                {rightChildren}
              </FlexItem>
            </FlexGrid>
          </FlexItem>
        </FlexGrid>
      </div>
    </div>
  )
}

SubNavigation.defaultProps = {
  items: [],
  breadcrumbs: []
}

SubNavigation.displayName = 'SubNavigation'

SubNavigation.propTypes = {
  active: PropTypes.string,
  breadcrumbs: PropTypes.array,
  items: PropTypes.array.isRequired,
  rightChildren: PropTypes.object,
  title: PropTypes.node
}

export default SubNavigation



// WEBPACK FOOTER //
// ./ui/SubNavigation.js